import {useContext} from 'react';
import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import './styles.scss';
import {translations} from '../../../../../../../i18n/translations';
import {AppContext} from '../../../../../../../contexts/app/context';
import {AppContextType} from '../../../../../../../contexts/app/types';
import {ThemeMode} from '../../../../../../../enums/theme-mode';
import {Pallete} from '../../../../../../../theme/bluebird';
import {InvitationType} from './renderer';

const Confirm = ({
  name,
  invitationType,
  institution,
}: {
  name: string;
  invitationType: InvitationType;
  institution: string;
}) => {
  const appContext: AppContextType = useContext(AppContext);

  const {t} = useTranslation();

  const splittedNames = name.split(' ');

  const hasMoreThanOneName = splittedNames.length >= 2;

  const firstName = hasMoreThanOneName ? splittedNames[0] : name;

  // Get title
  let title = translations.professional_caregivers.root.modals.add_staff_flow.confirm.confirm_title;

  // Check type
  if (invitationType === 'quickAccessCode') {
    title =
      translations.professional_caregivers.root.modals.add_staff_flow.confirm
        .confirm_title_quickAccessCode;
  }

  return (
    <Stack className="content-wrapper">
      <Typography
        component="h3"
        className="title"
        sx={{
          color:
            appContext.state.currentThemeMode === ThemeMode.Light
              ? Pallete.gray.base
              : Pallete.white.base,
        }}
      >
        {t(title, {
          name: firstName,
          institution,
        })}
      </Typography>
      <Typography
        component="h5"
        className="subtitle"
        sx={{
          color:
            appContext.state.currentThemeMode === ThemeMode.Light ? '#b6b6b6' : Pallete.gray.light,
        }}
      >
        {t(
          translations.professional_caregivers.root.modals.add_staff_flow.confirm.confirm_subtitle,
          {
            name: firstName,
            institution,
          }
        )}
      </Typography>
    </Stack>
  );
};

export default Confirm;
